import { defaults, noop, time } from '@motionone/utils';
import { stopAnimation } from './stop-animation.es.js';
var createAnimation = function createAnimation(factory) {
  return factory();
};
var withControls = function withControls(animationFactory, options) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaults.duration;
  return new Proxy({
    animations: animationFactory.map(createAnimation).filter(Boolean),
    duration: duration,
    options: options
  }, controls);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */
var getActiveAnimation = function getActiveAnimation(state) {
  return state.animations[0];
};
var controls = {
  get: function get(target, key) {
    var activeAnimation = getActiveAnimation(target);
    switch (key) {
      case "duration":
        return target.duration;
      case "currentTime":
        return time.s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
      case "playbackRate":
      case "playState":
        return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
      case "finished":
        if (!target.finished) {
          target.finished = Promise.all(target.animations.map(selectFinished))["catch"](noop);
        }
        return target.finished;
      case "stop":
        return function () {
          target.animations.forEach(function (animation) {
            return stopAnimation(animation);
          });
        };
      case "forEachNative":
        /**
         * This is for internal use only, fire a callback for each
         * underlying animation.
         */
        return function (callback) {
          target.animations.forEach(function (animation) {
            return callback(animation, target);
          });
        };
      default:
        return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : function () {
          return target.animations.forEach(function (animation) {
            return animation[key]();
          });
        };
    }
  },
  set: function set(target, key, value) {
    switch (key) {
      case "currentTime":
        value = time.ms(value);
      // Fall-through
      case "playbackRate":
        for (var i = 0; i < target.animations.length; i++) {
          target.animations[i][key] = value;
        }
        return true;
    }
    return false;
  }
};
var selectFinished = function selectFinished(animation) {
  return animation.finished;
};
export { controls, withControls };